import { render, staticRenderFns } from "./WaybillCreate.vue?vue&type=template&id=5cc4ff29&scoped=true&"
import script from "./WaybillCreate.vue?vue&type=script&lang=js&"
export * from "./WaybillCreate.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCreate.vue?vue&type=style&index=0&id=5cc4ff29&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4ff29",
  null
  
)

export default component.exports